/*
  uhren4you (04.11.2026, Guided 21): Reiter der Startseite („Collection tabs“) laden ihre Produktkarten nach.
  - Liste mit data-u4y-src wird mit <Kategorie-URL>?section_id=u4y-tab-items gefüllt (sections/u4y-tab-items.liquid).
  - Geladen wird, sobald der Bereich in die Nähe des Bildschirms kommt (in einer ruhigen Sekunde),
    spätestens beim Überfahren oder Anklicken des Reiters.
  - Klappt das Laden nicht, bleibt der Link „Alle anzeigen: <Reiter>“ zur Kategorie stehen.
*/
(function () {
  if (window.__u4yTabs) return;
  window.__u4yTabs = true;

  function load(ul) {
    if (ul.__u4yPromise) return ul.__u4yPromise;
    var src = ul.getAttribute('data-u4y-src');
    if (!src) return Promise.resolve();
    var url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'section_id=u4y-tab-items';
    ul.__u4yPromise = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('[data-u4y-tab-items] > li');
        if (!items.length) throw new Error('leer');
        var limit = parseInt(ul.getAttribute('data-u4y-limit') || '6', 10);
        var isSlider = ul.classList.contains('slider');
        var base = (ul.id || 'Slider-u4y').replace(/^Slider-/, 'Slide-');
        var frag = document.createDocumentFragment();
        var count = Math.min(items.length, limit);
        for (var i = 0; i < count; i++) {
          var li = document.importNode(items[i], true);
          li.id = base + '-' + (i + 1);
          li.className = 'grid__item' + (isSlider ? ' slider__slide' : '');
          frag.appendChild(li);
        }
        ul.innerHTML = '';
        ul.appendChild(frag);
        ul.removeAttribute('data-u4y-src');
        var slider = ul.closest('slider-component');
        if (slider) {
          var total = slider.querySelector('.slider-counter--total');
          if (total) total.textContent = count;
          if (typeof slider.resetPages === 'function') slider.resetPages();
        }
      })
      .catch(function () {
        /* Link zur Kategorie bleibt stehen */
      });
    return ul.__u4yPromise;
  }

  function loadAll(root) {
    root.querySelectorAll('ul[data-u4y-src]').forEach(load);
  }

  function idle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 });
    else setTimeout(fn, 600);
  }

  function init() {
    var sections = document.querySelectorAll('collection-tabs');
    sections.forEach(function (sec) {
      if (!sec.querySelector('ul[data-u4y-src]')) return;

      sec.querySelectorAll('.collection-tab').forEach(function (btn) {
        var go = function () {
          var panel = sec.querySelector('.collection-tab__content[data-content="' + btn.getAttribute('data-tab') + '"]');
          var ul = panel && panel.querySelector('ul[data-u4y-src]');
          if (ul) load(ul);
        };
        btn.addEventListener('pointerenter', go, { passive: true });
        btn.addEventListener('focus', go);
        btn.addEventListener('click', go);
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                io.unobserve(e.target);
                idle(function () { loadAll(e.target); });
              }
            });
          },
          { rootMargin: '600px 0px' }
        );
        io.observe(sec);
      } else {
        idle(function () { loadAll(sec); });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
